import translation from './translation.reducer'

const translationReducers = translation

export default translationReducers
